import React from 'react';
import styled, { css, CSSProperties } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { LinkButton, useLang, usePageEntity, SliceMainSectionLayout } from '@shapeable/ui';
import { Organisation } from '@shapeable/copper-connect-types';
import { ChevronRightThinIconGlyph } from '@shapeable/icons';

const cls = classNames('slice-austmine-link');

// -------- Types -------->

// -------- Props -------->

export type SliceAustmineLinkProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceAustmineLinkDefaultProps: Omit<SliceAustmineLinkProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ButtonStyles = breakpoints({
  base: css`
    max-width: 250px;

  `,
});


// -------- Components -------->

const My = {
  Container: styled(SliceMainSectionLayout)<ContainerProps>`${ContainerStyles}`,
  Button: styled(LinkButton)`${ButtonStyles}`,
};

export const SliceAustmineLink: Shapeable.FC<SliceAustmineLinkProps> = (props) => {
  const { className, children, entity } = props

  const t = useLang();

  const organisation = usePageEntity() as Organisation;

  const { alternativeUrl } = organisation;

  const styles: CSSProperties = {
    borderColor: '#FFF',
  }

  if (!alternativeUrl) {
    return null;
  }

  return (
    <My.Container className={cls.name(className)} entity={entity} >
      <My.Button 
        href={alternativeUrl} 
        buttonStyles={styles} 
        shape='rounded'
        variant='slim'
        borderStyle='solid'
        colors={{ 
          fill: 'line', border: 'line', text: 'line',
          hover: { 
            fill: 'mid', border: 'mid', text: 'mid'
          }
         }}
        icon={ChevronRightThinIconGlyph}
        >
        {t('Austmine Partner')}
      </My.Button>
    </My.Container>
  )
};

SliceAustmineLink.cls = cls;